
import dayjs from "dayjs";
import Vue from "vue";
import { mapFields } from "vuex-map-fields";

import { EAbortModal } from "@exp/vue";
import { ValidationService } from "@fkui/logic";
import { FForm, FFormStep, FLoader } from "@fkui/vue";
import FkRichtext from "fk-vue-richtext";

import { showComponentMixin, onPopStateMixin } from "@/utils/mixins";
import FkKontaktuppgifter from "@/views/Containers/FkKontaktuppgifter.vue";
import FkObservationer from "@/views/Containers/FkObservationer.vue";
import FkKontaktuppgifterSammanfattning from "@/views/Containers/FkKontaktuppgifterSammanfattning.vue";
import { kvittensSessionKey } from "@/constants";
import { KvittensSession } from "@/store/types";
import ContainerButton from "@/components/ContainerButton.vue";
import { AnmalanService } from "@/services/AnmalanService";

export default Vue.extend({
    name: "FkAnmalan",
    components: {
        EAbortModal,
        FForm,
        FFormStep,
        FkKontaktuppgifter,
        FkObservationer,
        FkKontaktuppgifterSammanfattning,
        FkRichtext,
        ContainerButton,
        FLoader,
    },
    mixins: [showComponentMixin, onPopStateMixin],
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const { vilkenroll, misstanke } = vm.$store.state.forsteg;
            if (!vilkenroll || !misstanke) {
                next("/forsteg");
            }
        });
    },
    data() {
        return {
            showAbortModal: false,
            inFlight: false,
        };
    },
    computed: {
        isFormDirty(): boolean {
            const files = this.$store.state.observationer.files || [];
            return ValidationService.isAnyTouched || files.length > 0;
        },
        ...mapFields([
            "kontaktuppgifter.anmalareVarJobbar",
            "kontaktuppgifter.anmalareDittFornamn",
            "kontaktuppgifter.anmalareDittEfternamn",
            "kontaktuppgifter.anmalareDinTelefon",
            "kontaktuppgifter.anmalareOvrigKontaktuppgift",
            "kontaktuppgifter.anmaldFornamn",
            "kontaktuppgifter.anmaldEfternamn",
            "kontaktuppgifter.anmaldPersonnummer",
            "kontaktuppgifter.anmaldKontaktuppgift",
            "kontaktuppgifter.foretagForetradare",
            "kontaktuppgifter.foretagNamn",
            "kontaktuppgifter.foretagOvrigaUppgifter",
            "kontaktuppgifter.organisationsnummer",
        ]),
    },
    created() {
        ValidationService.clearAllStates();
    },
    methods: {
        onAbortConfirm(): void {
            AnmalanService.abort();
        },
        onAbortClick(): void {
            if (!this.inFlight) {
                /* if the form is dirty we need to confirm before aborting */
                if (this.isFormDirty) {
                    this.showAbortModal = true;
                } else {
                    AnmalanService.abort();
                }
            }
        },
        onAbortDismiss(): void {
            this.showAbortModal = false;
        },
        async submitForm(): Promise<void> {
            if (!this.inFlight) {
                this.inFlight = true;
                const result = await AnmalanService.send(this.$store.state, this.$store.state.observationer.files);
                this.setSessionAndReroute(dayjs(result.headers.date).format("YYYY-MM-DD"));
            }
        },
        setSessionAndReroute(date: string): void {
            const kvittensSession: KvittensSession = {
                showErrorMessage: false,
                date,
                ...this.$store.state.forsteg,
            };
            sessionStorage.setItem(kvittensSessionKey, JSON.stringify(kvittensSession));
            this.$router.push("kvittens");
        },
    },
});
